// Shared test ids used across the app.
export const HOME = { emergentLink: "emergent-link" };

export const IDS = {
  landing: {
    hero: "landing-hero",
    ageA2: "age-a2-btn",
    ageB1: "age-b1-btn",
    signIn: "landing-signin-btn",
    signUp: "landing-signup-btn",
  },
  auth: {
    tabLogin: "auth-tab-login",
    tabRegister: "auth-tab-register",
    email: "auth-email-input",
    password: "auth-password-input",
    name: "auth-name-input",
    role: "auth-role-select",
    ageCategory: "auth-age-category-select",
    submit: "auth-submit-btn",
    guest: "auth-guest-btn",
  },
  dashboard: {
    root: "dashboard-root",
    readinessMeter: "readiness-meter",
    streak: "streak-widget",
    weakAreas: "weak-areas-widget",
    skillReading: "skill-card-reading",
    skillVocabulary: "skill-card-vocabulary",
    skillGrammar: "skill-card-grammar",
    skillListening: "skill-card-listening",
    skillWriting: "skill-card-writing",
    skillSpeaking: "skill-card-speaking",
    parentView: "parent-dashboard-link",
    logout: "logout-btn",
    linkCode: "student-link-code",
  },
  practice: {
    root: "practice-root",
    option: (i) => `practice-option-${i}`,
    submit: "practice-submit-btn",
    next: "practice-next-btn",
    explanation: "practice-explanation",
    playAudio: "practice-play-audio",
    generate: "practice-generate-btn",
  },
  writing: {
    root: "writing-root",
    textarea: "writing-textarea",
    submit: "writing-submit-btn",
    feedback: "writing-feedback",
  },
  speaking: {
    root: "speaking-root",
    record: "speaking-record-btn",
    stop: "speaking-stop-btn",
    submit: "speaking-submit-btn",
    transcript: "speaking-transcript",
    feedback: "speaking-feedback",
  },
  parent: {
    root: "parent-root",
    linkCodeInput: "parent-link-input",
    linkSubmit: "parent-link-submit",
    child: (id) => `parent-child-${id}`,
  },
};
